<template>
	<div class="d-flex flex-column overflow-auto">
		<DialogBody>
			<ProfileForm :profile="profile" :form-errors="formErrors" @change="handleProfile" />
		</DialogBody>
		<DialogActions
			:accept-action="{ text: $t('Common_Save_Button') }"
			cancel-action
			@accept="onAccept"
			@cancel="$emit('close')"
		/>
	</div>
</template>

<script setup lang="ts">
	import { ref, onMounted } from 'vue'
	import { Profile } from '~/models/Profile'
	import { ProfileActions } from '~/actions/profile/action'
	import { ProfileMetric } from '~/actions/metrics/profile'

	interface Props {
		profile: Profile
	}

	const props = defineProps<Props>()
	const emit = defineEmits(['accept', 'close'])

	const form = ref<Profile>({ ...props.profile })
	const formErrors = ref<Partial<Record<keyof Profile, string>>>({})

	onMounted(() => {
		ProfileMetric.viewEditDialog()
	})

	const handleProfile = (profileForm: Profile): void => {
		cleanErrors(profileForm)
		form.value = { ...profileForm }
	}

	const onAccept = async (): Promise<void> => {
		const errors = await ProfileActions.validateProfile(form.value)
		if (!errors) return emit('accept', form.value)
		formErrors.value = errors
	}

	const cleanErrors = (profileForm: Profile) => {
		Object.keys(profileForm).forEach((key) => {
			const theKey = key as keyof Profile
			if (profileForm[theKey] !== form.value[theKey]) {
				formErrors.value[theKey] = ''
			}
		})
	}
</script>
